import FeedbackTypeService from "../../services/feedback-type-service"

export const makeFeedbackTypeService = (): FeedbackTypeService => {
  return new FeedbackTypeService()
}
